var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.deptCode && !_vm.deptId)?_c('span',{staticClass:"text-danger"},[_vm._v("未认领")]):(_vm.departmentInfo && _vm.departmentInfo.name)?_c('span',[_vm._v(_vm._s(_vm.departmentInfo.name))]):_c('span',{staticClass:"text-danger"},[_vm._v("机构不存在")])
}
var staticRenderFns = []

export { render, staticRenderFns }